import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglePlayButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 191,
	height: 57,
	viewBox: "0 0 191 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M183.107 1.20898H7.15949C3.5959 1.20898 0.707031 4.09785 0.707031 7.66144V49.3489C0.707031 52.9125 3.5959 55.8013 7.15949 55.8013H183.107C186.671 55.8013 189.56 52.9125 189.56 49.3489V7.66144C189.56 4.09785 186.671 1.20898 183.107 1.20898Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.108 56.5H7.16066C3.20874 56.5 0 53.2913 0 49.3393V7.66066C0 3.70874 3.20874 0.5 7.16066 0.5H183.108C187.06 0.5 190.269 3.70874 190.269 7.66066V49.3393C190.269 53.2913 187.06 56.5 183.108 56.5ZM7.16066 1.91639C3.99563 1.91639 1.41639 4.49563 1.41639 7.6694V49.3481C1.41639 52.5131 3.99563 55.0923 7.16066 55.0923H183.108C186.273 55.0923 188.852 52.5131 188.852 49.3481V7.66066C188.852 4.48688 186.273 1.90765 183.108 1.90765H7.16066V1.91639Z",
			fill: "#A7A9AC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.9816 31.1273C92.6767 31.1273 89.9751 33.6454 89.9751 37.1076C89.9751 40.5699 92.668 43.088 95.9816 43.088C99.2953 43.088 101.988 40.5525 101.988 37.1076C101.988 33.6628 99.2953 31.1273 95.9816 31.1273ZM95.9816 40.7361C94.1718 40.7361 92.6068 39.241 92.6068 37.1076C92.6068 34.9743 94.1718 33.4792 95.9816 33.4792C97.7915 33.4792 99.3565 34.9481 99.3565 37.1076C99.3565 39.2672 97.7915 40.7361 95.9816 40.7361ZM82.8844 31.1273C79.5795 31.1273 76.8778 33.6454 76.8778 37.1076C76.8778 40.5699 79.5707 43.088 82.8844 43.088C86.198 43.088 88.8909 40.5525 88.8909 37.1076C88.8909 33.6628 86.198 31.1273 82.8844 31.1273ZM82.8844 40.7361C81.0745 40.7361 79.5095 39.241 79.5095 37.1076C79.5095 34.9743 81.0745 33.4792 82.8844 33.4792C84.6942 33.4792 86.2592 34.9481 86.2592 37.1076C86.2592 39.2672 84.6942 40.7361 82.8844 40.7361ZM67.304 32.9634V35.4989H73.3718C73.1882 36.924 72.7161 37.9645 71.9904 38.6902C71.1073 39.5732 69.7259 40.5437 67.304 40.5437C63.562 40.5437 60.6418 37.5273 60.6418 33.794C60.6418 30.0607 63.562 27.0443 67.304 27.0443C69.3237 27.0443 70.7926 27.8399 71.8767 28.8541L73.6691 27.0617C72.1478 25.6104 70.1368 24.5 67.304 24.5C62.1806 24.5 57.8789 28.6705 57.8789 33.7852C57.8789 38.9 62.1806 43.0705 67.304 43.0705C70.0669 43.0705 72.1565 42.1612 73.7827 40.465C75.4614 38.7863 75.9773 36.4344 75.9773 34.5284C75.9773 33.9426 75.9336 33.3918 75.8374 32.9459H67.2953L67.304 32.9634ZM131.016 34.9306C130.517 33.5929 128.996 31.1273 125.892 31.1273C122.788 31.1273 120.253 33.5492 120.253 37.1076C120.253 40.4563 122.788 43.088 126.189 43.088C128.935 43.088 130.517 41.4093 131.173 40.4388L129.136 39.0836C128.454 40.0803 127.527 40.7361 126.189 40.7361C124.852 40.7361 123.899 40.124 123.287 38.9262L131.287 35.6213L131.016 34.9393V34.9306ZM122.858 36.924C122.788 34.6158 124.651 33.4355 125.988 33.4355C127.029 33.4355 127.912 33.9601 128.209 34.7033L122.867 36.924H122.858ZM116.353 42.7208H118.985V25.1383H116.353V42.7208ZM112.052 32.4563H111.964C111.378 31.7568 110.242 31.1186 108.817 31.1186C105.826 31.1186 103.081 33.7503 103.081 37.1251C103.081 40.5 105.826 43.0792 108.817 43.0792C110.242 43.0792 111.378 42.441 111.964 41.724H112.052V42.5809C112.052 44.8716 110.828 46.0956 108.86 46.0956C107.252 46.0956 106.255 44.9415 105.844 43.9623L103.553 44.9153C104.209 46.4978 105.958 48.4475 108.852 48.4475C111.929 48.4475 114.535 46.6377 114.535 42.2137V31.477H112.043V32.4475L112.052 32.4563ZM109.035 40.7273C107.225 40.7273 105.704 39.206 105.704 37.1251C105.704 35.0443 107.225 33.4792 109.035 33.4792C110.845 33.4792 112.226 35.018 112.226 37.1251C112.226 39.2322 110.819 40.7273 109.035 40.7273ZM143.317 25.1383H137.031V42.7208H139.654V36.0585H143.317C146.229 36.0585 149.088 33.9514 149.088 30.6027C149.088 27.2541 146.229 25.147 143.317 25.147V25.1383ZM143.387 33.6104H139.654V27.5863H143.387C145.346 27.5863 146.465 29.2126 146.465 30.6027C146.465 31.9929 145.354 33.6191 143.387 33.6191V33.6104ZM159.606 31.0836C157.708 31.0836 155.741 31.923 154.928 33.7765L157.254 34.747C157.752 33.7765 158.679 33.4617 159.649 33.4617C161.005 33.4617 162.386 34.2749 162.412 35.7262V35.9098C161.94 35.6388 160.917 35.2279 159.676 35.2279C157.166 35.2279 154.613 36.6093 154.613 39.1885C154.613 41.5404 156.668 43.053 158.976 43.053C160.742 43.053 161.713 42.2574 162.325 41.3306H162.412V42.6858H164.948V35.9448C164.948 32.8235 162.622 31.0836 159.614 31.0836H159.606ZM159.291 40.7186C158.434 40.7186 157.236 40.2902 157.236 39.2235C157.236 37.8683 158.731 37.3437 160.017 37.3437C161.171 37.3437 161.713 37.5885 162.412 37.9295C162.211 39.5557 160.804 40.7098 159.291 40.7098V40.7186ZM174.172 31.4683L171.164 39.0923H171.077L167.955 31.4683H165.131L169.809 42.1175L167.142 48.0454H169.879L177.092 31.4683H174.172ZM150.539 42.712H153.162V25.1295H150.539V42.712Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8384 11.1489C14.4275 11.5773 14.1914 12.2505 14.1914 13.1249V44.1981C14.1914 45.0724 14.4362 45.7369 14.8384 46.174L14.9433 46.279L32.351 28.8713V28.4604L14.9433 11.0527L14.8384 11.1577V11.1489Z",
			fill: "#5BC9F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.157 34.6762L32.3516 28.8707V28.4598L38.157 22.6543L38.2882 22.733L45.1603 26.6412C47.1275 27.7603 47.1275 29.5789 45.1603 30.698L38.2882 34.6062L38.157 34.6849V34.6762Z",
			fill: "url(#paint0_linear_11873_130)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.2851 34.5987L32.3485 28.6621L14.8359 46.1747C15.4829 46.8566 16.5496 46.9441 17.7562 46.2621L38.2851 34.5987Z",
			fill: "url(#paint1_linear_11873_130)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.2851 22.7242L17.7562 11.0608C16.5496 10.3788 15.4829 10.4575 14.8359 11.1482L32.3485 28.6608L38.2851 22.7242Z",
			fill: "url(#paint2_linear_11873_130)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.6375 12.1466C64.1129 11.6745 63.4135 11.3772 62.6441 11.3772C60.9129 11.3772 59.584 12.8023 59.584 14.5597C59.584 16.3171 60.9129 17.7248 62.6441 17.7248C64.1304 17.7248 65.2146 16.8592 65.2845 15.4952H62.9326V14.5248H66.561C66.561 17.4275 65.0135 18.8002 62.6441 18.8002C60.2747 18.8002 58.4648 16.9029 58.4648 14.5597C58.4648 12.2166 60.2922 10.3105 62.6441 10.3105C63.737 10.3105 64.7249 10.7302 65.4419 11.4034L64.6375 12.1466Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.9791 10.4062V11.4467H69.1933V14.0871H72.4983V15.1363H69.1933V17.6369H73.0928V18.6773H68.0742V10.4062H72.9704H72.9791Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.2168 10.4062V11.4642H77.7075V18.6773H76.5796V11.4642H74.0703V10.4062H80.2168Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.5801 10.4062V18.6773H84.4609V10.4062H85.5801Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.1933 10.4062V11.4642H90.684V18.6773H89.5562V11.4642H87.0469V10.4062H93.1933Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.07 10.3105C103.439 10.3105 105.275 12.2078 105.275 14.5597C105.275 16.9116 103.439 18.8002 101.07 18.8002C98.7005 18.8002 96.8906 16.9029 96.8906 14.5597C96.8906 12.2166 98.7179 10.3105 101.07 10.3105ZM101.07 17.716C102.81 17.716 104.147 16.3084 104.147 14.5597C104.147 12.8111 102.818 11.386 101.07 11.386C99.3212 11.386 98.0097 12.8023 98.0097 14.5597C98.0097 16.3171 99.3387 17.716 101.07 17.716Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.876 18.6773L108.107 12.4434V18.6773H106.988V10.4062H108.09L111.823 16.5877V10.4062H112.942V18.6773H111.876Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_11873_130",
				x1: 43.8838,
				y1: 28.6609,
				x2: 9.88162,
				y2: 28.6609,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#FEE000" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .42,
						stopColor: "#FBBC0E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .78,
						stopColor: "#F9A318"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F99B1C"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_11873_130",
				x1: 35.0589,
				y1: 31.8883,
				x2: 3.08512,
				y2: 63.8621,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EF4547" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C6186D"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_11873_130",
				x1: 2.93648,
				y1: -6.67908,
				x2: 29.0436,
				y2: 19.428,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#279E6F" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .04,
						stopColor: "#2B9F6E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .46,
						stopColor: "#52B16B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8,
						stopColor: "#6BBC69"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#74C169"
					})
				]
			})
		] })
	]
});
export default SvgGooglePlayButton;
